module.exports = "/wwwroot/img/twitter-brands.svg?ver=bd20cbdd";